import EventPolicyCollection from './EventPolicyCollection';
import EventPolicyTemplateModel from './EventPolicyTemplateModel';

class EventPolicyTemplateCollection extends EventPolicyCollection {
  get url() {
    return '/api/ui/alerting/policy-templates/kevent';
  }

  get model() {
    return EventPolicyTemplateModel;
  }
}

export default EventPolicyTemplateCollection;
